import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { SnackbarHost } from './components'

import SnackbarContext from 'contexts/SnackbarContext'

import snackbarBus from './snackbarBus'

const SnackbarProvider = ({ children }) => {
  const contextValue = useMemo(
    () => ({ snackbar: { open: snackbarBus.show } }),
    [],
  )

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}

      <SnackbarHost />
    </SnackbarContext.Provider>
  )
}

SnackbarProvider.propTypes = {
  children: PropTypes.node,
}

export default SnackbarProvider
